import EventEmitter from "events";
import UserController from "../../../services/userController";
import {
  identifyUser,
  resetPostHog,
  userEvents,
} from "@/plugins/posthog-events";
// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const userlogin = "islogged";
const loginExpiryKey = "tokenExpiry";
const Userinfo = "userinfo";

class Auth extends EventEmitter {
  localLogin(authResult) {
    this.tokenExpiry = new Date();
    localStorage.setItem(loginExpiryKey, this.tokenExpiry);
    localStorage.setItem(userlogin, "true");
    localStorage.setItem(
      Userinfo,
      JSON.stringify({
        email: authResult.email,
        role: authResult.role,
        userid: authResult.userid,
        username: authResult.username,
        access: authResult.access,
      }),
    );
    // Identify user in PostHog and track login
    identifyUser(authResult.userid, authResult);
    userEvents.loggedIn("email", authResult);
  }

  async Logout() {
    localStorage.removeItem(loginExpiryKey);
    localStorage.removeItem(userlogin);
    localStorage.removeItem(Userinfo);
    // Clear inactive user data
    localStorage.removeItem("inactiveUserData");
    localStorage.removeItem("activationRequestTime");
    // Reset PostHog on logout
    resetPostHog();
    let response = await UserController.logout();
  }
  ForcefullyLogout() {
    localStorage.removeItem(loginExpiryKey);
    localStorage.removeItem(userlogin);
    localStorage.removeItem(Userinfo);
    // Clear inactive user data
    localStorage.removeItem("inactiveUserData");
    localStorage.removeItem("activationRequestTime");
    // Reset PostHog on forceful logout
    resetPostHog();
    window.location = "/";
  }
  isAuthenticated() {
    return (
      new Date(Date.now()) != new Date(localStorage.getItem(loginExpiryKey)) &&
      localStorage.getItem(userlogin) === "true"
    );
  }
  checAlive() {
    return this.Auth();
  }
  async Auth() {
    let response = await UserController.authenticate();
    if (response == true) {
      return true;
    } else {
      return false;
    }
  }
}

export default new Auth();
